import React from 'react';
import { Button } from './ui/Button';
export function Header() {
  const scrollToPurchase = () => {
    document.getElementById('elegir')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="bg-brand-bg border-b border-brand-sand sticky top-0 z-50 shadow-sm" data-id="element-73">
      
    </header>;
}